/*
参数:
url: 播放地址
playerId: vido标签的id

注意：
Chrome 66之后的版本已经禁用了自动播放功能
* */

window.startPlay = function (urls, playerId, auto, muted, loop) {
    var options = {
        width: "100%",
        height: "100%",
        fluid: false,
        language: "zh-CN",
        controls: true,
        crossOrigin: "Anonymous",
        autoplay: auto === true,
        loop: loop === true,
        muted: muted === true,
        sources: [],
        // 新增HLS配置，解决跨域和请求问题
        html5: {
            hls: {
                overrideNative: true, // 强制使用js解析HLS，而非Chrome原生
                maxRetries: 5,
                retryDelay: 1000,
            },
        },
    };

    var playUrls = [];
    if (Object.prototype.toString.call(urls) === "[object Array]") {
        if (urls.length === 0) {
            return;
        }
        playUrls = urls;
    } else {
        playUrls = [urls];
    }

    var playlist = [];
    var url = playUrls[0];
    if (_.endsWith(getBaseUrl(url), ".m3u8")) {
        // options['techOrder'] = ['html5', 'flash'];
        // options['flash'] = {
        //     params: {
        //         wmode: 'Opaque'
        //     },
        //     swf: '/videojs/video-js.swf'
        // };
        for (var i = 0; i < playUrls.length; i++) {
            var url = playUrls[i];
            playlist.push({
                sources: [
                    {
                        type: "application/x-mpegURL",
                        src: url,
                    },
                ],
            });
        }
        // for (var url of playUrls) {
        //     playlist.push(
        //         {
        //             sources: [{
        //                 type: 'application/x-mpegURL',
        //                 src: url
        //             }]
        //         }
        //     );
        // }
    } else if (_.endsWith(getBaseUrl(url), ".flv")) {
        options["techOrder"] = ["html5", "Flvjs"];
        options["Flvjs"] = {
            mediaDataSource: {
                isLive: true,
                cors: true,
                withCredentials: false,
            },
        };
        options["flash"] = {
            params: {
                wmode: "Opaque",
            },
            swf: "/videojs/video-js.swf",
        };

        // for (var urll of playUrls) {
        //     playlist.push(
        //         {
        //             sources: [{
        //                 type: 'video/x-flv',
        //                 src: urll
        //             }]
        //         }
        //     );
        // }
        for (var i = 0; i < playUrls.length; i++) {
            var urll = playUrls[i];
            playlist.push({
                sources: [
                    {
                        type: "video/x-flv",
                        src: urll,
                    },
                ],
            });
        }
    } else if (_.startsWith(url, "rtmp://")) {
        options["techOrder"] = ["html5", "flash"];
        options["flash"] = {
            params: {
                wmode: "Opaque",
            },
            swf: "/videojs/video-js.swf",
        };

        // for (var urlll of playUrls) {
        //     playlist.push(
        //         {
        //             sources: [{
        //                 type: 'rtmp/mp4',
        //                 src: urlll
        //             }]
        //         }
        //     );
        // }
        for (var i = 0; i < playUrls.length; i++) {
            var urlll = playUrls[i];
            playlist.push({
                sources: [
                    {
                        type: "rtmp/mp4",
                        src: urlll,
                    },
                ],
            });
        }
    } else {
        // for (var urllll of playUrls) {
        //     playlist.push(
        //         {
        //             sources: [{
        //                 type: 'video/mp4',
        //                 src: urllll
        //             }]
        //         }
        //     );
        // }
        for (var i = 0; i < playUrls.length; i++) {
            var urllll = playUrls[i];
            playlist.push({
                sources: [
                    {
                        type: "video/mp4",
                        src: urllll,
                    },
                ],
            });
        }
    }

    videojs.Hls.xhr.beforeRequest = function (options) {
        if (_.endsWith(getBaseUrl(options.uri), ".m3u8")) {
            options.uri = updateQueryStringParameter(
                options.uri,
                "_t",
                new Date().valueOf()
            );
        }

        // options.headers = {
        //     'Cache-Control': 'no-cache, no-store'
        // };
        return options;
    };

    var player = videojs.getPlayer(playerId);
    if (player) {
        removeplayer();
    }

    player = videojs(playerId, options);
    player.playlist(playlist);
    player.playlist.autoadvance(0);
    player.ready(function () {});

    return player;
};

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
}

window.getBaseUrl = function (url) {
    var pos = url.indexOf("?");
    if (pos === -1) {
        return url;
    } else {
        return url.substr(0, pos);
    }
};

window.removeplayer = function (playerId) {
    if ($("#" + playerId).length > 0) {
        var parent = $("#" + playerId).parent();
        videojs(playerId).dispose();
        parent.append(
            '<video id="' +
                playerId +
                '" class="video-js vjs-big-play-centered"></video>'
        );
        $("#" + playerId).show();
    }
};

window.showPlayMsg = function (msg) {};
